import { useState } from "react";
import { FiBarChart2 } from "react-icons/fi";
import { VideoSearchToggle } from "./VideoCards";
// The FAQ picker sends its groundingModel value as the Root Agent model setting.
import {
  ChatSettingsPicker,
  ALL_MODEL_OPTIONS,
} from "../../Faq/components/ChatSettingsControls";
import MyUsageModal from "../../../../components/usageBilling/MyUsageModal";

export default function AssistantControls({
  includeVideo,
  setIncludeVideo,
  language,
  verbosity,
  setVerbosity,
  thinking,
  setThinking,
  model,
  setModel,
  footerNote,
}) {
  const [usageOpen, setUsageOpen] = useState(false);

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center gap-2">
        <VideoSearchToggle
          checked={includeVideo}
          onChange={setIncludeVideo}
          language={language}
        />
        <ChatSettingsPicker
          verbosity={verbosity}
          onVerbosityChange={setVerbosity}
          thinking={thinking}
          onThinkingChange={setThinking}
          groundingModel={model}
          onGroundingModelChange={setModel}
          modelOptions={ALL_MODEL_OPTIONS}
          language={language}
          triggerClassName="inline-flex max-w-full flex-wrap items-center gap-2 bg-orange-500 dark:bg-white/10 hover:bg-orange-600 dark:hover:bg-white/20 text-white px-3 py-2 rounded-2xl border border-white/20 transition-colors text-sm font-medium"
          priceNote={
            language === "zh"
              ? "費用與延遲為 FAQ 服務實測值，此頁尚未實測，僅供相對比較參考。"
              : "Measured against the FAQ service, not this one — use for relative comparison only."
          }
          showBillingRates
        />
        {/* Only this chat is billed (it runs on the Root Agent), so the usage
            button lives here and not in the ChatInput PIMS Chat shares. */}
        <button
          type="button"
          onClick={() => setUsageOpen(true)}
          title={
            language === "zh"
              ? "查看本週與本週期的 AI 用量"
              : "See your AI usage this week and this cycle"
          }
          className="inline-flex items-center gap-1.5 rounded-2xl border px-3 py-2 text-sm font-medium transition-colors bg-transparent border-black/20 dark:border-white/20 text-gray-600 dark:text-gray-300 hover:border-orange-500 hover:text-orange-600 dark:hover:text-orange-400"
        >
          <FiBarChart2 className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
          {language === "zh" ? "我的用量" : "My usage"}
        </button>
      </div>
      {usageOpen && (
        <MyUsageModal
          onClose={() => setUsageOpen(false)}
          language={language}
        />
      )}
      <p className="mt-2 text-center text-xs text-black/70 dark:text-white/70 italic">
        {footerNote}
      </p>
    </div>
  );
}
